import React from 'react';
import { connect } from 'react-redux';
import AssignmentPropTypes from '../assignment_prop_types';

import AssignmentRequirements from './assignment_requirements';
import ContractDetails from './contract_details';

export class RequirementsCard extends React.Component {
  static propTypes = {
    ...AssignmentPropTypes
  };

  render() {
    return (
      <div className="d-flex flex-column gap-8">
        <div>
          <h6 className="mb-2">Requirements</h6>
          <AssignmentRequirements assignment={this.props.assignment}/>
        </div>
        {['Under Contract', 'Closed'].includes(this.props.assignment.status) &&
          <div>
            <h6 className="mb-2">Contract Details</h6>
            <ContractDetails assignment={this.props.assignment}/>
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps({ assignment }) {
  return { assignment };
}

export default connect(mapStateToProps)(RequirementsCard);
